import { temAcesso } from '@/shared/auth/temAcesso'

const Contratos = () => import('./Contratos.vue')
const ContratoDetalhar = () =>
    import('../../gescon/contratos/ContratoDetalhar.vue')
const ContratoRequisicoes = () =>
    import('../../gescon/requisicoes/Requisicoes.vue')
const ContratoRequisicaoDetalhar = () =>
    import('../../gescon/requisicoes/RequisicaoDetalhar.vue')
const ContratoComprometimentos = () =>
    import('../../gescon/comprometimentos/Comprometimentos.vue')

export default {
    path: 'contratos',
    name: 'FornecedorContratos',
    component: Contratos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('FORN-CONTRATOS-00')) {
            next()
        }
    },
    children: [
        {
            path: ':codContrato',
            name: 'FornecedorContratos_Detalhar',
            component: ContratoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FORN-CONTRATOS-00')) {
                    next()
                }
            },
            children: [
                {
                    path: 'requisicoes',
                    name: 'FornecedorContratos_Requisicoes',
                    component: ContratoRequisicoes,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('FORN-CONTRATOS-00')) {
                            next()
                        }
                    },
                    children: [
                        {
                            path: ':idRequisicao',
                            name: 'FornecedorContratos_RequisicaoDetalhar',
                            component: ContratoRequisicaoDetalhar,
                            beforeEnter: (to, from, next) => {
                                if (temAcesso('FORN-CONTRATOS-00')) {
                                    next()
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'servicos',
                    name: 'FornecedorContratos_Comprometimentos',
                    component: ContratoComprometimentos,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('FORN-CONTRATOS-00')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
